export default "__VITE_ASSET__D64GZKn2__"